"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceBucket = void 0;
class PriceBucket {
}
exports.PriceBucket = PriceBucket;
//# sourceMappingURL=price-bucket.js.map